import { useQuery } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import {
  getChargeAttemptStatistics,
  getChargeAttempts,
  getFailedInvoices,
  getChargeableInvoices
} from '../requests/payment.request';
import {
  ChargeAttemptsFilters,
  FailedInvoicesParams,
  StatisticsParams,
  ChargeableInvoicesParams
} from '../types/payment.types';

export const useChargeAttemptStatisticsQuery = (params: StatisticsParams = {}) => {
  return useQuery({
    queryKey: ['charge-attempt-statistics', params],
    queryFn: async () => await getChargeAttemptStatistics(params),
    onError: () => {
      toast.error("Couldn't fetch charge attempt statistics", { id: 'statistics-error' });
    }
  });
};

export const useChargeAttemptsQuery = (filters: ChargeAttemptsFilters = {}) => {
  return useQuery({
    queryKey: ['charge-attempts', filters],
    queryFn: async () => await getChargeAttempts(filters),
    onError: () => {
      toast.error("Couldn't fetch charge attempts", { id: 'charge-attempts-error' });
    }
  });
};

export const useFailedInvoicesQuery = (params: FailedInvoicesParams = {}) => {
  return useQuery({
    queryKey: ['failed-invoices', params],
    queryFn: async () => await getFailedInvoices(params),
    onError: () => {
      toast.error("Couldn't fetch failed invoices", { id: 'failed-invoices-error' });
    }
  });
};

export const useChargeableInvoicesQuery = (
  params: ChargeableInvoicesParams = {},
  enabled = true
) => {
  return useQuery({
    queryKey: ['chargeable-invoices', params],
    queryFn: async () => await getChargeableInvoices(params),
    enabled,
    onError: () => {
      toast.error("Couldn't fetch chargeable invoices", { id: 'chargeable-invoices-error' });
    }
  });
};
